export const VOCAB_CONSTANTS = {
  TOTAL_CHAPTERS: 9,
  WORDS_PER_CHAPTER: 25,
  LISTENING_TIMEOUT: 5000,
  DEFAULT_DIALOG_STATE: "আপনার উত্তরের জন্য অপেক্ষা করছি",
  LISTENING_STATE: "আমি শুনছি। এই ইংরেজি শব্দটি উচ্চারণ করুন।",
};
